function replaceFilenameDots(filename: string) {
  return filename.replace(/\./g, '_');
}

export function saveBlob(blob: Blob, filename: string) {
  const normalizedFilename = replaceFilenameDots(filename);

  if ('msSaveOrOpenBlob' in window.navigator) {
    (window.navigator as Navigator & {
      msSaveOrOpenBlob?: (data: Blob, defaultName?: string) => void;
    }).msSaveOrOpenBlob?.(blob, normalizedFilename);
    return;
  }

  const link = document.createElement('a');
  document.body.appendChild(link);
  const url = window.URL.createObjectURL(blob);

  link.href = url;
  link.download = normalizedFilename;
  link.click();

  setTimeout(() => {
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }, 0);
}
